import { AppEnvironmentConfig } from "@tt-lib/interfaces/app-environment-config";

export const environment = <AppEnvironmentConfig>{
  production: true,
  BASEURL: "https://topomapviewer.ngi.be",  
  AC_BASEURL: "https://ac.ngi.be",
  AC_TRACE_DOWNLOAD_APP_ID: 30,
  AC_IMAGE_DOWNLOAD_APP_ID: 28,
  OSRM_BASEURL: "https://topomapviewer.ngi.be/snaptoroad", 
	OSRM_URL_SUFFIX: "/",
  ELEVATION_BASEURL: "https://topomapviewer.ngi.be/elevation-service", 
  URL_SUFFIX: "/",
  TRACE_SUGGESTIONS_CONFIG: "",
  GEOCODINGv2_BASEURL: "https://geosearchviewer.ngi.be/geosearchengine"
};

/**
 * SP-INT/SI/SD
 * AC_BASEURL: "http://sp-ac-manager-1.int.ngi.be/ac",
 * 
 * DMZ
 * AC_BASEURL: "https://ac.ngi.be"
 * 
 * 
 * 
 * 
 * 21 chars
 * routage automatique
 * Op de wegen snappen
 * ajustement automatique sur les routes et chemins
 * ajustement sur les routes
 * 
 */